import AbstractAccordion from './AbstractAccordion'
import { shallowRef } from 'vue'
import LinksComponent from '@/modules/common/common/components/insuranceAccordions/LinksComponent.vue'

export default class AccordionLinks extends AbstractAccordion<{
  link: string
  linkText: string
  text: string
  title: string
}> {
  component = shallowRef(LinksComponent)

  constructor(attributes: Partial<AccordionLinks>) {
    super(attributes)
  }
}
